import { render, staticRenderFns } from "./ReportProductOrderService.vue?vue&type=template&id=68f87705&"
import script from "./ReportProductOrderService.vue?vue&type=script&lang=js&"
export * from "./ReportProductOrderService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports